import { useMemo } from 'react';
import SmartTextFeature from '../../../components/features/smartTextFeatures/smartTextFeature';
import { useNoteState } from '../../../context/noteContexts/noteContext';
import { useColorContext } from '../../../context/colorContext';

const ReadView = ({ listContent: listContentProp, listTitles: listTitlesProp }) => {
	const { list_content_smart_text, list_title_smart_text } = useNoteState();
	const {
		activeAccent,
		bgPrimary,
		bgSecondary,
		textPrimary,
		textSecondary,
		bgTertiary,
	} = useColorContext();

	const colors = useMemo(() => ({
		accentColor: activeAccent || '#10B981',
		bgPrimary: bgPrimary || '#111111',
		bgSecondary: bgSecondary || '#191919',
		textPrimary: textPrimary || '#F0F0F0',
		textSecondary: textSecondary || '#BDBDBD',
		borderColor: bgTertiary || '#1E1E1E',
	}), [activeAccent, bgPrimary, bgSecondary, textPrimary, textSecondary, bgTertiary]);

	const sizes = useMemo(() => ({
		container: { width: '100%', maxWidth: '1280px', margin: '0 auto' },
		item: { minHeight: '56vh', marginBottom: '20px' },
	}), []);

	const listContent = Array.isArray(listContentProp) ? listContentProp : list_content_smart_text;
	const listTitles = Array.isArray(listTitlesProp) ? listTitlesProp : list_title_smart_text;

	if (!listContent || listContent.length === 0) {
		return (
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					minHeight: '400px',
					color: colors.textSecondary,
					fontSize: '16px',
					fontFamily: 'system-ui, -apple-system, sans-serif',
				}}
			>
				No smart text content available. Please generate content first.
			</div>
		);
	}

	return (
		<div
			style={{
				padding: '14px 12px',
				backgroundColor: colors.bgPrimary,
				minHeight: '100%',
			}}
		>
			<div style={sizes.container}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '16px',
					}}
				>
					{listContent.map((markdownContent, index) => {
						const title = listTitles?.[index] || `Section ${index + 1}`;

						return (
							<div key={`smart-text-${index}`} style={sizes.item}>
								<SmartTextFeature
									markdownText={markdownContent}
									title={title}
									colors={colors}
									sizes={{
										height: '64vh',
										minHeight: 520,
										borderRadius: '12px',
									}}
									showHeader={true}
									enableFullscreen={true}
								/>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default ReadView;
